export interface PimProductsCategories {
  [key: string]: TranslationBinding[];
}

export interface PimProductAttribute {
  locale: string; // PK, SK in GSI
  id: string; // SK
  category: string; // PK in GSI
  keyName: string;
  translatedValue: string;
  createdAt: string;
  updatedAt: string;
}

export interface TranslationBinding {
  keyName: string;
  translatedValue: string;
}

export enum LocaleEnum {
  af_ZA = "Afrikaans, South Africa",
  ar_AE = "Arabic, United Arab Emirates",
  ar_BH = "Arabic, Bahrain",
  ar_DZ = "Arabic, Algeria",
  ar_EG = "Arabic, Egypt",
  ar_IQ = "Arabic, Iraq",
  ar_JO = "Arabic, Jordan",
  ar_KW = "Arabic, Kuwait",
  ar_LY = "Arabic, Libya",
  ar_MA = "Arabic, Morocco",
  ar_OM = "Arabic, Oman",
  ar_QA = "Arabic, Qatar",
  ar_SA = "Arabic, Saudi Arabia",
  ar_TN = "Arabic, Tunisia",
  ar_YE = "Arabic, Yemen",
  as_IN = "Assamese, India",
  az_AZ = "Azerbaijani, Azerbaijan",
  be_BY = "Belarusian, Belarus",
  bg_BG = "Bulgarian, Bulgaria",
  bn_IN = "Bengali, India",
  bs_BA = "Bosnian, Bosnia and Herzegovina",
  ca_ES = "Catalan, Spain",
  cs_CZ = "Czech, Czech Republic",
  da_DK = "Danish, Denmark",
  de_AT = "German, Austria",
  de_BE = "German, Belgium",
  de_CH = "German, Switzerland",
  de_DE = "German, Germany",
  de_LI = "German, Liechtenstein",
  de_LU = "German, Luxembourg",
  el_CY = "Greek, Cyprus",
  el_GR = "Greek, Greece",
  en_AU = "English, Australia",
  en_BW = "English, Botswana",
  en_CA = "English, Canada",
  en_GB = "English, United Kingdom",
  en_HK = "English, Hong Kong SAR China",
  en_IE = "English, Ireland",
  en_IN = "English, India",
  en_MT = "English, Malta",
  en_NZ = "English, New Zealand",
  en_PH = "English, Philippines",
  en_SG = "English, Singapore",
  en_US = "English, U.S.A.",
  en_ZW = "English, Zimbabwe",
  es_AR = "Spanish, Argentina",
  es_BO = "Spanish, Bolivia",
  es_CL = "Spanish, Chile",
  es_CO = "Spanish, Colombia",
  es_CR = "Spanish, Costa Rica",
  es_DO = "Spanish, Dominican Republic",
  es_EC = "Spanish, Ecuador",
  es_ES = "Spanish, Spain",
  es_GT = "Spanish, Guatemala",
  es_HN = "Spanish, Honduras",
  es_MX = "Spanish, Mexico",
  es_NI = "Spanish, Nicaragua",
  es_PA = "Spanish, Panama",
  es_PE = "Spanish, Peru",
  es_PR = "Spanish, Puerto Rico",
  es_PY = "Spanish, Paraguay",
  es_SV = "Spanish, El Salvador",
  es_US = "Spanish, U.S.A.",
  es_UY = "Spanish, Uruguay",
  es_VE = "Spanish, Venezuela",
  et_EE = "Estonian, Estonia",
  fi_FI = "Finnish, Finland",
  fr_BE = "French, Belgium",
  fr_CA = "French, Canada",
  fr_CH = "French, Switzerland",
  fr_FR = "French, France",
  fr_LU = "French, Luxembourg",
  gu_IN = "Gujarati, India",
  he_IL = "Hebrew, Israel",
  hi_IN = "Hindi, India",
  hr_HR = "Croatian, Croatia",
  hu_HU = "Hungarian, Hungary",
  hy_AM = "Armenian, Armenia",
  id_ID = "Indonesian, Indonesia",
  is_IS = "Icelandic, Iceland",
  it_CH = "Italian, Switzerland",
  it_IT = "Italian, Italy",
  ja_JP = "Japanese, Japan",
  ka_GE = "Georgian, Georgia",
  kk_KZ = "Kazakh, Kazakhstan",
  kn_IN = "Kannada, India",
  ko_KR = "Korean, Korea",
  ks_IN = "Kashmiri, India",
  ku_TR = "Kurdish, Turkey",
  ky_KG = "Kirghiz, Kyrgyzstan",
  lt_LT = "Lithuanian, Lithuania",
  lv_LV = "Latvian, Latvia",
  mk_MK = "Macedonian, Macedonia",
  ml_IN = "Malayalam, India",
  mr_IN = "Marathi, India",
  ms_MY = "Malay, Malaysia",
  mt_MT = "Maltese, Malta",
  nb_NO = "Bokmal, Norway",
  nl_BE = "Dutch, Belgium",
  nl_NL = "Dutch, Netherlands",
  nn_NO = "Nynorsk, Norway",
  or_IN = "Oriya, India",
  pa_IN = "Punjabi, India",
  pl_PL = "Polish, Poland",
  pt_BR = "Portuguese, Brazil",
  pt_PT = "Portuguese, Portugal",
  ro_RO = "Romanian, Romania",
  ru_RU = "Russian, Russia",
  ru_UA = "Russian, Ukraine",
  sa_IN = "Sanskrit, India",
  sk_SK = "Slovak, Slovakia",
  sl_SI = "Slovenian, Slovenia",
  sq_AL = "Albanian, Albania",
  sr_ME = "Serbian, Montenegro",
  sr_RS = "Serbian, Serbia",
  sv_SE = "Swedish, Sweden",
  ta_IN = "Tamil, India",
  te_IN = "Telugu, India",
  th_TH = "Thai, Thailand",
  tr_TR = "Turkish, Turkey",
  uk_UA = "Ukrainian, Ukraine",
  vi_VN = "Vietnamese, Vietnam",
  zh_CN = "Simplified Chinese, China",
  zh_HK = "Traditional Chinese, Hong Kong SAR China",
  zh_SG = "Chinese, Singapore",
  zh_TW = "Traditional Chinese, Taiwan",
}
